import { C, F, Card, SectionHead } from '../../../tokens';

// Placeholder shell — non-functional connection cards. No auth, no wiring.
const SOURCES = [
  { name:"TempWorks",              desc:"Staffing and applicant data." },
  { name:"HubSpot",                desc:"CRM, deals, and marketing activity." },
  { name:"QuickBooks",             desc:"Accounting, invoices, and cash flow." },
  { name:"Manual Upload",          desc:"Drop in spreadsheets or documents by hand." },
  { name:"Future API Connections", desc:"Additional systems Compass will support over time." },
];

export default function DataSourcesTab() {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <SectionHead title="Data Sources" sub="Where Compass draws its understanding of the business from. Connections are not yet active." />
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill, minmax(240px, 1fr))",gap:12}}>
        {SOURCES.map(s=>(
          <Card key={s.name} style={{padding:"18px 20px",display:"flex",flexDirection:"column",gap:6}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}}>
              <div style={{fontFamily:F.display,fontSize:15,color:C.charcoal,fontWeight:600}}>{s.name}</div>
              <span style={{fontFamily:F.mono,fontSize:9,color:C.charLight,textTransform:"uppercase",letterSpacing:".08em",border:`1px solid ${C.border}`,borderRadius:5,padding:"2px 7px"}}>Not connected</span>
            </div>
            <div style={{fontFamily:F.body,fontSize:12,color:C.charMid,lineHeight:1.5}}>{s.desc}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
